import type { PostStatusDto } from '@gr/core/content/posts/dto';
import { MetaStatus } from '@gr/core/content/posts/meta-status';

/** Значения формы статуса (POST-UC-9); цвет хранится в верхнем регистре. */
export interface StatusValues {
  name: string;
  color: string;
  meta: MetaStatus;
}

export const STATUS_FORM_FIELDS = ['name', 'color', 'meta'] as const;

/** Цвет нового статуса по умолчанию — нейтральный серый. */
export const NEW_STATUS: StatusValues = { name: '', color: '#A3A3A3', meta: MetaStatus.Draft };

export function statusValuesOf(status: Pick<PostStatusDto, 'name' | 'color' | 'meta'>): StatusValues {
  return { name: status.name, color: status.color, meta: status.meta };
}

export function normalizedStatus(values: StatusValues): StatusValues {
  return { ...values, color: values.color.toUpperCase() };
}

/** Чем заменить удаляемый статус у его постов (POST-UC-9.CC-1): статус с тем же метастатусом, иначе первый. */
export function replacementFor(status: Pick<PostStatusDto, 'id' | 'meta'>, all: readonly Pick<PostStatusDto, 'id' | 'meta'>[]): string {
  const others = all.filter((s) => s.id !== status.id);
  return others.find((s) => s.meta === status.meta)?.id ?? others[0]?.id ?? '';
}
